import AddressDisplay from 'common/components/address/AddressDisplay';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';
import { phoneFormat } from 'common/helpers/phoneHelper';

const DisplayAddress = (props) => {
  const { clubMembership, customer, onEdit } = props;
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit();
  };

  const { orderDeliveryMethod } = clubMembership;
  if (orderDeliveryMethod === 'Pickup') {
    return (
      <>
        {renderCustomer(customer.data)}
        <strong>Pick Up At</strong>
        <br />
        <AddressOnlyDisplay address={clubMembership.pickupAt} />
        <br />
        <a onClick={handleEdit} className="c7-button-alt-small">
          Edit
        </a>
      </>
    );
  }
  if (orderDeliveryMethod === 'Ship' && clubMembership.shipTo) {
    return (
      <>
        <strong>Ship To</strong>
        <br />
        <AddressDisplay address={clubMembership.shipTo} />
        <br />
        <a onClick={handleEdit} className="c7-button-alt-small">
          Edit
        </a>
      </>
    );
  }
  return (
    <>
      <strong>Ship to</strong>
      <br />
      <div className="c7-message--error" onClick={handleEdit}>
        Error: Missing Address
      </div>
      <br />
      <a onClick={handleEdit} className="c7-button-alt-small">
        Add Address
      </a>
    </>
  );
};

export default DisplayAddress;

const renderCustomer = (customer) => {
  if (!customer) {
    return null;
  }
  return (
    <>
      <strong>Pickup By</strong>
      <br />
      <strong>
        {customer.firstName} {customer.lastName}
      </strong>
      <br />
      Phone:{' '}
      {customer.phones &&
        customer.phones[0] &&
        phoneFormat(customer.phones[0].phone, customer.countryCode)}
      <br />
      <br />
    </>
  );
};
